import styled from "styled-components";

import { IThemeProps } from "@/styles/Theme";

export const Section = styled.section<IThemeProps>`
  display: block;
  margin: 0 auto;
  min-height: ${(props) => props.theme.globals.minInteractionHeight};
  width: 100%;
`;

export const Wrapper = styled.div<IThemeProps>`
  display: flex;
  height: 100%;
  min-height: ${(props) => props.theme.globals.minInteractionHeight};
  align-items: center;
  justify-content: center;
  flex-flow: column;
  padding: 20px;
`;

export const Title = styled.h3<IThemeProps>`
  display: block;
  margin: 0 auto;
  text-align: center;
  margin-top: 15px;
  font-size: ${(props) => props.theme.typography.h700};
  font-weight: ${(props) => props.theme.globals.fontWeightBold};
`;

export const ContentBox = styled.div<IThemeProps>`
  display: block;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  background-color: ${(props) => props.theme.colors.white};
  margin-top: ${(props) => props.theme.spacing.desktop.s400}px;
`;

export const Text = styled.p<IThemeProps>`
  display: block;
  margin: 0 auto;
  text-align: center;
  font-size: ${(props) => props.theme.typography.h700};
`;

export const ButtonWrap = styled.div<IThemeProps>`
  display: block;
  margin: 0 auto;
  margin-top: ${(props) => props.theme.spacing.desktop.s400}px;
`;

export const SharingWrap = styled.div<IThemeProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${(props) => props.theme.spacing.desktop.s400}px;
  svg,
  path {
    fill: ${(props) => props.theme.colors.button100};
  }
`;

export const Image = styled.img<IThemeProps<{ $showOnlyImage: boolean }>>`
  position: relative;
  display: block;
  margin: 0 auto;
  overflow: hidden;
  background-color: ${(props) => props.theme.colors.white};
  border-color: ${(props) => props.theme.colors.white};
  border-style: solid;
  border-width: ${(props) => props.theme.borders.imageTile};
  box-shadow: ${(props) => props.theme.shadows.s200};
  width: 100%;
  height: auto;
  transition: all 0.25s ease-in;
  margin-top: ${(props) => (props.$showOnlyImage ? "0" : "10px")};
`;
